import IndustryChecklistI18n from "@/components/landing/shared/IndustryChecklistI18n";
const ChecklistEinzelhandelSection = () => <IndustryChecklistI18n translationPrefix="industryEinzelhandel" />;
export default ChecklistEinzelhandelSection;
